<template>
  <kt-panel>
    <kt-panel-body>
        <kt-datatable ref="datatable" v-bind="datatableProps"></kt-datatable>
    </kt-panel-body>
  </kt-panel>
</template>

<script>
import {ApiUrl} from "@/common/api.service";
import {AuthorizationHeader} from "@/common/jwt.service";
import columns from "../datatable/profit-columns.js";

export default {
    data() {
        return {
            query: {},
        };
    },
    methods: {
        filterAction(e, query) {
            this.query = query;

            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload();
            }
        },
    },
    computed: {
        datatableProps() {
            return {
                id: "profit_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.starshopPath('wallet/common/admin/profit'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: res => {
                                return res.data.data;
                            },
                            params: this.query,
                        }
                    },
                    pageSize: 10,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },
                layout: {},
                pagination: false,
                columns: columns,
            }
        },
    },
}
</script>
